import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ScorecardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  max-width: 1000px;
  margin: 6rem auto 2rem;
  width: calc(100% - 40px);
  @media (max-width: 1050px) {
    grid-column-gap: 0.25rem;
    grid-row-gap: 0.25rem;
  }
  @media (max-width: 875px) {
    grid-template-columns: 1fr;
    grid-row-gap: 1rem;
    max-width: 500px;
  }

`;

const ScorecardHalf = styled.div`
  text-align: center;
  text-transform: uppercase;
  h5 {
    font-size: 0.875rem;
    line-height: 1rem;
    letter-spacing: 0.25px;
    font-family: var(--block-font);
  }
  p {
    font-size: 0.75rem;
    line-height: 0.875rem;
  }
`;

const HolesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  grid-column-gap: 3px;
  margin-top: 0.5rem;
  @media (max-width: 1050px) {
    grid-column-gap: 1px;
  }
`;

const ScorecardHole = styled.div`
  text-align: center;
  button {
    border-radius: 50%;
    width: clamp(25px, 4vw, 40px);
    height: clamp(25px, 4vw, 40px);
    line-height: 0;
    padding: 0;
    background-color: initial;
    border: 1px solid var(--custom-green);
    color: var(--custom-green);
    margin-bottom: 0.25rem;
    cursor: pointer;
    transition: background-color 0.25s ease-out;
    font-family: 'Alfa Slab One';
    &:hover {
      background-color: var(--custom-green);
      color: white;
    }
    &.selected {
      background-color: var(--custom-green);
      color: white;
    }
  }
  p {
    font-size: 0.75rem;
    line-height: 1rem;
    text-transform: uppercase;
  }
  @media (max-width: 1050px) {
    button {
      width: clamp(30px, 6vw, 40px);
      height: clamp(30px, 6vw, 40px);
      font-size: 0.875rem;
      line-height: 0.875rem;
    }
    p {
      font-size: 0.6125rem;
      line-height: 0.75rem;
    }
  }
`;

const Scorecard = ({ data, currentHole, setCurrentHole }) => {
  const frontNine = data.edges.slice(0, 9);
  const backNine = data.edges.slice(9);

  const updateHole = (e) => {
    const holeNum = e.target.getAttribute('data-hole');
    setCurrentHole(parseInt(holeNum, 10));
  };

  return (
    <ScorecardWrapper>
      <ScorecardHalf>
        <h5>Front nine</h5>
        <p className="benton-n4">Par 35, 3,556 yds</p>
        <HolesWrapper>
          {frontNine.map((row) => (
            <ScorecardHole key={`scorecard-hole-${row.node.hole}`}>
              <button
                type="button"
                className={currentHole === parseInt(row.node.hole, 10) ? ' selected' : null}
                data-hole={row.node.hole}
                onClick={updateHole}
              >
                {row.node.hole}
              </button>
              <p className="bentonsanscond-n4">Par {row.node.par}</p>
              <p className="bentonsanscond-n4">{row.node.yards} yds</p>
            </ScorecardHole>
          ))}
        </HolesWrapper>
      </ScorecardHalf>

      <ScorecardHalf>
        <h5>Back nine</h5>
        <p className="benton-n4">Par 35, 3,708 yds</p>
        <HolesWrapper>
          {backNine.map((row) => (
            <ScorecardHole key={`scorecard-hole-${row.node.hole}`}>
              <button
                type="button"
                className={currentHole === parseInt(row.node.hole, 10) ? 'selected' : null}
                data-hole={row.node.hole}
                onClick={(e) => updateHole(e)}
              >
                {row.node.hole}
              </button>
              <p className="bentonsanscond-n4">Par {row.node.par}</p>
              <p className="bentonsanscond-n4">{row.node.yards} yds</p>
            </ScorecardHole>
          ))}
        </HolesWrapper>
      </ScorecardHalf>
    </ScorecardWrapper>
  );
};

Scorecard.propTypes = {
  data: PropTypes.shape({
    edges: PropTypes.arrayOf.isRequired,
  }).isRequired,
  currentHole: PropTypes.number.isRequired,
  setCurrentHole: PropTypes.func.isRequired,
};

export default Scorecard;
